import { faTag } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import cx from 'classnames'

import useStyles from './Tag.styles'

interface TagProps {
  label: string
  appearance: 'valid' | 'invalid' | 'empty'
  title?: string
  hideIcon?: boolean
  iconOnly?: boolean
}

const Tag = ({ label, appearance, title, hideIcon, iconOnly }: TagProps) => {
  const classes = useStyles()

  const icon = (
    <span
      className={cx(
        classes.icon,
        iconOnly && classes.iconNoMargin,
        appearance.toLocaleLowerCase() === 'valid' && classes.valid,
        appearance.toLocaleLowerCase() === 'invalid' && classes.invalid,
        appearance.toLocaleLowerCase() === 'empty' && classes.empty
      )}
    >
      <FontAwesomeIcon icon={faTag} />
    </span>
  )

  if (iconOnly) return <span title={title}>{icon}</span>

  return (
    <span title={title}>
      {!hideIcon && icon}
      {label}
    </span>
  )
}

export default Tag
